/**
 * Balli tiered free-gift unlock.
 * Cart total (excluding gift lines) unlocks gift slots by tier:
 *   >= t1 -> 1 gift, >= t2 -> 2 gifts, >= t3 -> 3 gifts.
 * Customers Claim / Remove gifts; excess gifts are auto-removed if the cart
 * drops below a tier. Gift lines carry properties[_balli_gift]=1.
 */
(function () {
  var GIFT_PROP = '_balli_gift';
  var busy = false;

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function eligibleTotal(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (item.properties && String(item.properties[GIFT_PROP]) === '1') return;
      total += item.final_line_price;
    });
    return total;
  }

  function giftItems(cart) {
    return (cart.items || []).filter(function (item) {
      return item.properties && String(item.properties[GIFT_PROP]) === '1';
    });
  }

  function allowedFor(total, t1, t2, t3) {
    var a = 0;
    if (total >= t1) a = 1;
    if (total >= t2) a = 2;
    if (total >= t3) a = 3;
    return a;
  }

  function tiers() {
    var root = document.querySelector('[data-balli-gift]');
    return {
      t1: root ? parseInt(root.dataset.t1, 10) : Infinity,
      t2: root ? parseInt(root.dataset.t2, 10) : Infinity,
      t3: root ? parseInt(root.dataset.t3, 10) : Infinity
    };
  }

  function changeLine(key, quantity) {
    var url = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change';
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function addGift(variantId) {
    var props = {};
    props[GIFT_PROP] = '1';
    var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: props }] })
    }).then(function (r) { return r.json(); });
  }

  function refreshCartUI() {
    var drawer = document.querySelector('cart-drawer');
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections });
        } else if (window.location.pathname.indexOf('/cart') !== -1) {
          window.location.reload();
        } else {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) {
            var html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (html) bubble.innerHTML = html.innerHTML;
          }
        }
      })
      .catch(function () {
        if (window.location.pathname.indexOf('/cart') !== -1) window.location.reload();
      });
  }

  // Remove any gift lines beyond what the current tier allows (sequential, keys stay valid).
  function removeExcess(cart, allowed) {
    var gifts = giftItems(cart);
    if (gifts.length <= allowed) return Promise.resolve(null);
    var excess = gifts.slice(allowed);
    var chain = Promise.resolve();
    excess.forEach(function (g) { chain = chain.then(function () { return changeLine(g.key, 0); }); });
    return chain.then(refreshCartUI);
  }

  function syncGiftState() {
    if (busy) return Promise.resolve();
    var root = document.querySelector('[data-balli-gift]');
    if (!root) return Promise.resolve();
    var t = tiers();
    busy = true;
    return fetchCart()
      .then(function (cart) {
        var allowed = allowedFor(eligibleTotal(cart), t.t1, t.t2, t.t3);
        return removeExcess(cart, allowed);
      })
      .finally(function () { busy = false; });
  }

  function onPick(event) {
    var btn = event.target.closest('[data-balli-gift-pick]');
    if (!btn || btn.disabled || busy) return;
    var action = btn.getAttribute('data-action');
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    busy = true;
    btn.classList.add('is-loading');

    fetchCart()
      .then(function (cart) {
        var t = tiers();
        var allowed = allowedFor(eligibleTotal(cart), t.t1, t.t2, t.t3);
        var gifts = giftItems(cart);

        if (action === 'remove') {
          var it = gifts.filter(function (g) { return String(g.variant_id) === String(variantId); })[0];
          if (it) return changeLine(it.key, 0).then(refreshCartUI);
          return null;
        }

        // claim
        var already = gifts.some(function (g) { return String(g.variant_id) === String(variantId); });
        if (already) return null;
        if (gifts.length >= allowed) return null; // no free slot at this tier
        return addGift(variantId).then(refreshCartUI);
      })
      .catch(function (err) { console.warn('[balli-gift]', err); })
      .finally(function () { busy = false; btn.classList.remove('is-loading'); });
  }

  document.addEventListener('click', onPick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGiftState);
  } else {
    syncGiftState();
  }

  document.addEventListener('shopify:section:load', syncGiftState);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(syncGiftState, 120); });
  }
})();
